import { ThemeType, Theming } from "@pandas/core-ui";

export const configStyle = (configTheming: Theming, theme?: ThemeType) => {
	console.log(configTheming);
	const themeToUse = theme ?? "light";
	document.documentElement.classList.toggle("dark", themeToUse === "dark");
	document.documentElement.style.setProperty("--primary-color", configTheming.brandColor);
	document.documentElement.style.setProperty("--button-color", configTheming.buttonColor);
	document.documentElement.style.setProperty("--border-radius", configTheming.buttonBorderRadius);
	document.documentElement.style.setProperty("--background-homepage", `url("${configTheming.assets.webappHomePage}")`);
	document.documentElement.style.setProperty("--background-digitizer", `url("${configTheming.assets.digitizerImage}")`);
};
